module.exports = __webpack_public_path__ + "static/media/Finnovex-South-Africa-2023.1b418a81.png";